var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.572452 10.1133H6.86942V30.4353H0.572452V10.1133ZM3.72094 0C5.62911 0 7.34646 1.71735 7.34646 3.72094C7.34646 5.72452 5.72452 7.25105 3.72094 7.25105C1.71735 7.25105 0 5.62911 0 3.62553C0 1.62195 1.71735 0 3.72094 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.877 10.1131H16.9831V12.9753H17.0785C17.8418 11.3534 20.0362 9.73145 23.0893 9.73145C29.4816 9.73145 30.6265 13.9294 30.6265 19.4631V30.4351H24.3296V20.7034C24.3296 18.3182 24.3296 15.2651 21.0857 15.2651C17.8418 15.2651 17.2693 17.8412 17.2693 20.4172V30.4351H10.9724C10.877 30.5305 10.877 10.1131 10.877 10.1131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.70305d99c229a626fbc704027bbef431.svg";
export { ForwardRef as ReactComponent };